// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__futura_937e5a', '__futura_Fallback_937e5a'","fontWeight":700,"fontStyle":"normal"},"className":"__className_937e5a","variable":"__variable_937e5a"};